<template>
  <div>
    <v-dialog v-model="cancelDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="title">Cancel</v-card-title>
        <v-card-text>Are you sure you want to Cancel this {{ title }}{{ type==="multiple" ? "(s)" : "" }}?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-tooltip top>
            <v-btn slot="activator" flat @click="saveCancelDialog">
              <v-icon color="green">check</v-icon>
            </v-btn>
            <span>Yes</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn slot="activator" flat @click="closeCancelDialog">
              <v-icon color="pink">close</v-icon>
            </v-btn>
            <span>No</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: String,
    cancelDialog: Boolean
  },
  data() {
    return {};
  },
  methods: {
    saveCancelDialog() {
      this.$emit("saveCancelDialog");
    },
    closeCancelDialog() {
      this.$emit("closeCancelDialog");
    }
  }
};
</script>

<style>
</style>
